import { all, fork, takeEvery } from 'redux-saga/effects';
import {
  DELETE_CLIENT,
  LOAD_CLIENTS,
  UPDATE_CLIENT,
  LOAD_CLIENT_PAYMENTS,
  DELETE_CLIENT_PAYMENT,
  UPDATE_CLIENT_PAYMENT,
  UPDATE_CLIENT_INVOICE,
  LOAD_CLIENT_INVOICE,
  DELETE_CLIENT_INVOICE,
  LOAD_CLIENT_INVOICE_BY_ID,
} from 'constants/ActionTypes';
import { deleteEntity, loadEntities, updateEntity } from 'helpers/utilHelpers';

function* updateClientPayment() {
  yield takeEvery(UPDATE_CLIENT_PAYMENT, updateEntity);
}

function* deleteClientPayment() {
  yield takeEvery(DELETE_CLIENT_PAYMENT, deleteEntity);
}

function* loadClientPayments() {
  yield takeEvery(LOAD_CLIENT_PAYMENTS, loadEntities);
}

function* loadClients() {
  yield takeEvery(LOAD_CLIENTS, loadEntities);
}

function* updateClient() {
  yield takeEvery(UPDATE_CLIENT, updateEntity);
}

function* deleteClient() {
  yield takeEvery(DELETE_CLIENT, deleteEntity);
}

function* loadClientInvoices() {
  yield takeEvery(LOAD_CLIENT_INVOICE, loadEntities);
}

function* loadClientInvoiceById() {
  yield takeEvery(LOAD_CLIENT_INVOICE_BY_ID, loadEntities);
}

function* updateClientInvoice() {
  yield takeEvery(UPDATE_CLIENT_INVOICE, updateEntity);
}

function* deleteClientInvoice() {
  yield takeEvery(DELETE_CLIENT_INVOICE, deleteEntity);
}

export default function* rootSaga() {
  yield all([
    fork(updateClientPayment),
    fork(deleteClientPayment),
    fork(loadClientPayments),
    fork(loadClients),
    fork(updateClient),
    fork(deleteClient),
    fork(updateClientInvoice),
    fork(loadClientInvoices),
    fork(deleteClientInvoice),
    fork(loadClientInvoiceById),
  ]);
}
